import { ProductOrganizationDialogConfig, FieldType, ProductOrganizationTableTemplate } from '../../product.model';

export const hotelsDialogConfig: ProductOrganizationDialogConfig = {
	title: 'Hotele',
	configType: 'hotels',
	fields: [
		{ key: 'name', label: 'Nazwa', type: FieldType.TEXT, required: true },
		{ key: 'www', label: 'WWW', type: FieldType.TEXT, required: true, placeholder: 'https://example.com' },
		{ key: 'email', label: 'Email', type: FieldType.EMAIL, required: true, placeholder: 'example@gmail.com' },
		{ key: 'phone', label: 'Tel.', type: FieldType.PHONE, placeholder: '+48123123123' },
		{ key: 'note', label: 'Notatka', type: FieldType.TEXTAREA },
	],
};

export const hotelsTableTemplate: ProductOrganizationTableTemplate[] = [
	...hotelsDialogConfig.fields.map((field) => ({
		key: field.key,
		label: field.label,
	})),
	{ key: 'createdBy', label: 'Utworzone przez' },
	{ key: 'createdAt', label: 'Utworzone' },
	{ key: 'edit', label: '' },
];
